<template>
    <div class="products position-relative" id="products">
        <ProductFilter 
            @filter="filter" 
            :is-bookmarks="showBookmarks"
            @bookmarks="showBookmarks = !showBookmarks"
            @showFilter="showFilter"
            :services="services" 
            :productLevels="productLevels"
        />
        <SearchByNameFilter @filter="filter" />
        <ProductBox v-for="product in list" :key="product.id" :product="product"/>
        <Loading v-if="loading"/>
    </div>
</template>

<script>
import { getProducts, getServices, getProductLevels } from '../api'
import ProductFilter from '../components/product/ProductFilter'
import ProductBox from '../components/product/ProductBox'
import Loading from '../components/Loading'
import SearchByNameFilter from '../components/product/SearchByNameFilter'

export default {
    name: 'Products',
    components: {Loading, ProductBox, ProductFilter,SearchByNameFilter},
    data () {
        return {
            products: [],
            page: 1,
            community: [],
            types: null,
            total: 0,
            loading: false,
            showBookmarks: false,
            newOnly: 0,
            filterShow: false,
            services: [],
            service: false,
            productLevels: [{name: ''}, {name: ''}],
            name: []
        }
    },
    methods: {
        async filter (e) {
            this.products = []
            this.loading = true
            this.community = e.community ? e.community : this.community
            this.types = e.types
            this.page = 1
            this.newOnly = e.newOnly
            this.productLevel = e.productLevel
            this.service = e.service ? e.service : []
            if (this.filterShow) {
                const res = await getProducts(
			this.page, 
			this.community, 
			this.types, 
			this.newOnly, 
			this.productLevel,
			this.service
		)
              
                this.products = res.data
            }
            if (e.name) {
                this.name = e.name
                const res = await getProducts(
                    this.page, 
                    this.community, 
                    this.types, 
                    this.newOnly, 
                    this.productLevel, 
                    this.service,
                    this.name
                )
                this.products = res.data
            }

            
            this.loading = false
            
            // this.total = res.meta.total
        },
        showFilter(e) {
            this.filterShow = e
        }
    },
    async created () {
        this.loading = true
        const res = await getProducts(this.page)
        const resService = await getServices()
        const resProductLevels = await getProductLevels()
        this.services = resService.data
        this.products = res.data
        this.productLevels = resProductLevels.data
        this.total = res.meta.total
        this.loading = false

    },
    computed: {
        list () {
            return this.showBookmarks ? this.bookmarks : this.products
        },
        bookmarks() {
            return this.$store.getters.bookmarks
        }
    },
    mounted () {
        window.onscroll = async () => {
            if (
                (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200
                && this.total > this.products.length
                && !this.loading
                && !this.showBookmarks
            ) {
                this.loading = true
                const res = await getProducts(this.page + 1, this.community, this.types)
                this.page = res.meta.current_page
                this.products = this.products.concat(res.data)
                this.total = res.meta.total
                this.loading = false
            }
        }
    },
    destroyed () {
        window.onscroll = null
    }
}
</script>

<style scoped lang="scss">
    .products{
        min-height: calc(100vh - 320px)
    }
</style>
